import React from 'react'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

const pulse = keyframes`
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
`

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #4a4a4a 0%, #2d2d2d 50%, #1a1a1a 100%);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent, rgba(255,255,255,0.1), transparent);
    animation: ${pulse} 3s ease-in-out infinite !important;
    animation-duration: 3s !important;
    pointer-events: none;
  }
`

const SpinnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  z-index: 1;
`

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  border-top-color: #ffffff;
  animation: ${spin} 1s ease-in-out infinite !important;
  animation-duration: 1s !important;
`

const LoadingText = styled.div`
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
  animation: ${pulse} 2s ease-in-out infinite !important;
  animation-duration: 2s !important;
`

const SubText = styled.div`
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  margin-top: 8px;
  animation: ${pulse} 2.5s ease-in-out infinite !important;
  animation-duration: 2.5s !important;
`

interface LoadingSpinnerProps {
  text?: string
  subText?: string
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  text = "페이지 전환 중...", 
  subText = "잠시만 기다려주세요" 
}) => {
  return (
    <LoadingContainer>
      <SpinnerWrapper>
        <Spinner />
        <LoadingText>{text}</LoadingText>
        <SubText>{subText}</SubText>
      </SpinnerWrapper>
    </LoadingContainer>
  )
}

export default LoadingSpinner